module.exports = __webpack_public_path__ + "img/ics_f_thumb-neutral-white.4c17f2e2.svg";